import { useTranslation } from 'react-i18next';
import AdminAppBar from '../AppBar';
import Dashboard from '../Dashboard';

const DashboardPage = () => {
    const { t } = useTranslation('shiftBidding', { keyPrefix: 'admin.common' });
    return (
        <>
            <AdminAppBar
                name={t('appName')}
                pageName={t('adminDashboard')}
            />
            <Dashboard />
        </>
    );
};

export default DashboardPage;
